import * as _ from 'lodash';
import { isRetina } from 'utils/media';


export const receiverImgName = (row: any) => {
  const image = _.get(row, 'image');
  const name = _.get(row, 'name');
  const imgClass = 'receiver-logo';
  const imgItem = image ? `<img class='${imgClass}' src='${image}'/>` :
    `<div class='${imgClass} no-img-grey-icon'></div>`;

  return `
    <div class='receiver-wrap'>
      <div class='receiver-logo-wrap'>
        ${imgItem}
      </div>
      <span class='receiver-name text-ellipsis'>
        ${name}
      </span>
    </div>
    `;
};

export const receiverHardcodedImgName = (row: any) => {
  const image = isRetina() ? _.get(row, 'image2x') : _.get(row, 'image');
  const name = _.get(row, 'name');
  const imgClass = 'receiver-logo';
  const imgItem = image ? `<img class='${imgClass}' src='${image}'/>` :
    `<div class='${imgClass} no-img-grey-icon'></div>`;

  return `
    <div class='receiver-wrap'>
      <div class='receiver-logo-wrap'>
        ${imgItem}
      </div>
      <span class='receiver-name text-ellipsis'>
        ${name}
      </span>
    </div>`;
};
